// An error in one line, for a log line or a report that has no room for a stack: its name and
// message (a DOMException that is no Error included), without a trailing full stop, or the value
// itself. crash.ts's describeError() is the one with the stack and the cause chain.
export function errorNameAndMessage(error: unknown): string {
  if (error instanceof Error || error instanceof DOMException) {
    return `${error.name}: ${error.message.replace(/\.$/, '')}`;
  }
  return String(error);
}
